<template>
<g class="hc-hexapie-tagged-arc">
  <arc
    class="hc-hexapie-arc"
    :value="Value"
    :color="color"
  ></arc>
  <text
    class="hc-hexapie-text"
    :x="centroid[0]"
    :y="centroid[1]"
    text-anchor="middle"
    :transform="transform"
  >
    {{value.value}}%
  </text>
</g>
</template>

<script>
import { arc } from 'd3-shape'
import Arc from '../shapes/Arc'
import tween from '../libraries/tween'
// 0 picxel arc at the end of the pie
// if the pie is sliced this may change
const nullArc = function () {
  return {
    data: 0,
    endAngle: 6.283185307179586,
    index: -1,
    padAngle: 0,
    startAngle: 6.283185307179586,
    value: 0
  }
}
export default {
  name: 'TaggedArc',
  components: {
    Arc
  },
  props: {
    value: {
      type: Object,
      default: nullArc
    },
    color: {
      type: String,
      default: '#666666'
    },
    outerRadius: {
      type: Number,
      default: 200
    },
    innerRadius: {
      type: Number,
      default: 0
    },
    scale: {
      type: Number,
      default: 1
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    }
  },
  data () {
    return {
      Value: nullArc(),
      centroidX: 0,
      centroidY: 0
    }
  },
  created () {
    if (this.animation) {
      tween(this.value, nullArc(), this.animationDuration, (value) => {
        this.Value = value
      }, this.animationOptions)
    } else {
      this.Value = this.value
    }
  },
  watch: {
    value (newValue, oldValue) {
      if (this.animation) {
        tween(newValue, oldValue, this.animationDuration, (value) => {
          this.Value = value
        }, this.animationOptions)
      } else {
        this.Value = this.value
      }
    }
  },
  computed: {
    centroid () {
      return arc()
        .outerRadius(this.outerRadius)
        .innerRadius(this.innerRadius).centroid(this.Value)
    },
    transform () {
      return `scale(${this.scale}) rotate(-90, ${this.centroid[0]} ${this.centroid[1]})`
    }
  }
}
</script>

<style>

</style>
